import { useRouter } from 'next/router'

import { ModalPlanDetailsVariants } from '@/cmsComponents/ModalPlanDetails'
import RetainQueryLink from '@/components/RetainQueryLink/RetainQueryLinkDefault'
import { PlanDetails, useTonPlans } from '@/contexts/plans'
import cn from '@/utils/cn'

import { pageModeProps } from '../CalculatorTabs'

interface CalculatorMachineLinkToProps {
  planDetails: PlanDetails
  className?: string
  selectMode?: pageModeProps
}

const CalculatorMachineLinkTo: React.FC<CalculatorMachineLinkToProps> = ({
  planDetails,
  className
}) => {
  const { pathname } = useRouter()
  const { plansByGroupTier } = useTonPlans()
  const tiers = plansByGroupTier.get(planDetails.groupTier) || []
  const hasTiers = tiers.length > 1

  const isPagePlan = ['/pro', '/super'].includes(pathname)

  return (
    <div className={cn('font-medium ton-paragraph-16', className)}>
      {hasTiers && <>Taxas de acordo com as vendas mensais. </>}

      {isPagePlan && (
        <RetainQueryLink
          href={{
            hash: 'know-fees'
          }}
        >
          <span className="font-medium text-newTon-700 underline ton-paragraph-16">
            Veja como funciona o {planDetails.commercial_name}
          </span>
        </RetainQueryLink>
      )}

      {!isPagePlan && (
        <span
          className="text-newTon-700 underline cursor-pointer"
          data-group-tier={planDetails.groupTier}
          data-variant={
            planDetails.promotional
              ? ModalPlanDetailsVariants.Promotional
              : ModalPlanDetailsVariants.Default
          }
        >
          Veja como funciona o {planDetails.commercial_name}
        </span>
      )}
    </div>
  )
}

export default CalculatorMachineLinkTo
